// extracted by mini-css-extract-plugin
module.exports = {"container":"TabContainer_container__VV85_","left":"TabContainer_left__2eh9N"};